import { RouteObject } from 'react-router-dom';
import GuestGuard from '../guards/GuestGuard';
import AuthLayout from '@/layouts/AuthLayout';
import { lazyRetry } from '@/utils/lazyRetry';

export const authRoutes: RouteObject = {
    element: <GuestGuard />,
    children: [
        {
            path: '/auth',
            element: <AuthLayout />,
            children: [
                {
                    path: "login",
                    lazy: async () => {
                        const module = await lazyRetry(() => import("@/views/authentication/pages/LoginPage"));
                        return { element: <module.default /> };
                    },
                },
            ]
        }
    ]
}; 